export default {
  apiKey: "AIzaSyC1tZHKJXcTqRp_5L2WFJJeWMQz3QknnE8",
  authDomain: "arai-portfolio.firebaseapp.com",
  databaseURL: "https://arai-portfolio.firebaseio.com",
  projectId: "arai-portfolio",
  storageBucket: "arai-portfolio.appspot.com",
  messagingSenderId: "909464818513"
}